export const CUSTOMER = 'customer';
export const PARTNER = 'partner';
